import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { loaderGif } from '../../assets/images/login';
import styles from '../../features/formAfterSignUp/FormAfterSignUp.module.css';
import PaymentModal from './PaymentGatewayModal';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import jwtDecode from 'jwt-decode';
import ReactGA from 'react-ga4';

type TProps = {
  showSuccessModal?: boolean;
  setShowSuccessModal?: React.Dispatch<React.SetStateAction<boolean>>;
  img?: string;
  description?: string;
  header?: string;
  bottomText?: string | JSX.Element;
  pageComingFrom: 'Signup' | 'Login' | 'FORGOTPASSWORD' | 'SecurityQuestions';
  closePreviousModal?: () => void;
  proceedText?: string;
  whereTo?: string;
};

export default function SuccessModal({
  showSuccessModal = false,
  setShowSuccessModal = () => {
    return;
  },
  img = loaderGif,
  header = 'Successful',
  description = '',
  bottomText,
  // pageComingFrom = 'Login',
  closePreviousModal = () => {
    return;
  },
  proceedText = 'Proceed',
  whereTo,
}: TProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    showSuccessModal && closePreviousModal();
  }, [closePreviousModal, showSuccessModal]);

  const { ageOfBusiness } = useAppSelector((state) => state.auth.loggedInUserDetails);
  const whereToFromLogin = ageOfBusiness === 'yet to start' ? '/about/business' : '/dashboard';

  const token: any = localStorage.getItem('login-token');
  const signupToken = localStorage.getItem('signup-token');
  const queryParams = new URLSearchParams(location.search);
  const passwordToken = queryParams?.get('token') ?? '';
  if (token || signupToken || passwordToken) {
    const ttoken = token ?? signupToken ?? passwordToken;
    try {
      const details: any = jwtDecode(ttoken);

      return (
        <>
          {showSuccessModal ? (
            <>
              <div className='fixed inset-0 z-[50000] overflow-y-auto'>
                <div className='fixed inset-0 w-full h-full bg-black opacity-40'></div>
                <div className='flex items-center min-h-screen px-6 py-4'>
                  <div className='relative p-[2.6em] sm:py-[64px] sm:px-[64px] mx-auto bg-white rounded-md shadow-lg'>
                    <div className='sm:mt-[1.5em] max-w-[300px] md:max-w-[400px] sm:flex justify-center'>
                      <div className=' text-center sm:text-left font-[Poppins]'>
                        <div className='mb-2'>
                          <img src={img} alt='success.gif' className='h-[100px] sm:h-[180px]' />
                        </div>
                        <div className='text-[#229698] font-bold text-[24px] font-["Poppins"] leading-[30px]'>
                          {header}
                        </div>
                        <div className='text-[14px] leading-[21px] text-[#212121] mt-2 mb-6 font-[Poppins]'>
                          {description}
                        </div>
                        <div className='items-center justify-center gap-2 mt-3 sm:flex'>
                          {proceedText === 'PROCEED TO PAYMENT' ? (
                            <button
                              onClick={() => {
                                setShow(true);
                                registerNetcoreActivity(
                                  {
                                    emailAddress: details?.email,
                                    firstName: details?.firstName,
                                    lastName: details?.lastName,
                                    mobileNumber: details?.phoneNumber,
                                  },
                                  'TBH_BUSINESS_REGISTRATION_STEP_10',
                                );
                                ReactGA.event({
                                  category: 'formSubmit',
                                  action: 'TBH_BUSINESS_REGISTRATION_STEP_10',
                                  label: 'TBH_BUSINESS_REGISTRATION_STEP_10',
                                  // value: 1
                                });
                              }}
                              className={[
                                styles.bgColor,
                                'w-56 md:w-72 mt-2 p-2.5 flex-1 text-white outline-none rounded-[6px]',
                              ].join(' ')}
                            >
                              {proceedText}
                            </button>
                          ) : (
                            <Link to={whereTo ?? whereToFromLogin}>
                              <button
                                className={[
                                  styles.bgColor,
                                  'w-56 md:w-72 mt-2 p-2.5 flex-1 text-white outline-none rounded-[6px]',
                                ].join(' ')}
                                onClick={() => {
                                  if (whereTo === '/') {
                                    registerNetcoreActivity(
                                      {
                                        emailAddress: details.email,
                                        firstName: details && details.firstName,
                                        lastName: details && details.lastName,
                                        mobileNumber: details && details.phoneNumber,
                                      },
                                      'TBH_SIGN_UP_USER_REDIRECTS_TO_LOGIN_AFTER_SETTING_SECURITY_QUESTIONS',
                                    );
                                    ReactGA.event({
                                      category: 'Button',
                                      action:
                                        'TBH_SIGN_UP_USER_REDIRECTS_TO_LOGIN_AFTER_SETTING_SECURITY_QUESTIONS',
                                      label:
                                        'TBH_SIGN_UP_USER_REDIRECTS_TO_LOGIN_AFTER_SETTING_SECURITY_QUESTIONS',
                                      // value: 1
                                    });
                                  }
                                  localStorage.removeItem('newPassword_token');
                                  localStorage.removeItem('reseting-password');
                                }}
                              >
                                {proceedText}
                              </button>
                            </Link>
                          )}
                        </div>
                        {bottomText && <div>{bottomText}</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}

          <PaymentModal show={show} setShow={setShow} setShowSuccessModal={setShowSuccessModal} />
        </>
      );
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }
  //  else {
  //   console.error('Token not found in localStorage');
  // }

  return null;
}
